import clsx from 'clsx';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import CheckMark from '../../../assets/images/grey-check-icon.svg';

import { OfferOption } from '../../utils/backend-api/subscribe';
import { SelectedOffer } from '../../utils/backend-api/subscribe';
import { YOUNG_PROFESSIONALS_PLAN } from '../../utils/subscriptionCardOptions';
import Offer from './Offer';

interface SingleOffersProps {
  description?: string;
  offer: OfferOption;
  selectedOffer: SelectedOffer;
}

const BENEFITS = [
  'Read in-depth stories you won’t find anywhere else',
  'Subscribe to our suite of newsletters',
  'Attend monthly live events',
  'Read on the go with The Information app',
];

const SingleOffer = ({ description, offer, selectedOffer }: SingleOffersProps) => {
  const isYPPlan = offer.code.includes(YOUNG_PROFESSIONALS_PLAN);

  return (
    <div>
      <div
        className={clsx('tw-h-min-auto', {
          'sm:tw-min-h-[132px]': isYPPlan,
          'sm:tw-min-h-[188px]': !isYPPlan,
        })}
      >
        <h2 className="tw-mt-24 tw-mb-20 tw-font-serif tw-font-normal">
          {ReactHtmlParser(offer.header)}
        </h2>
        <p className="tw-text-body-lg tw-font-serif tw-text-gray-600">
          {description || ReactHtmlParser(offer.subHeader)}
        </p>
      </div>
      <div className="tw-mt-24 tw-mb-20 tw-flex tw-items-center">
        <div className="tw-text-primary-red tw-text-body-sm tw-uppercase tw-font-bold tw-font-sans">
          Special Offer
        </div>
        <div className="tw-ml-12 tw-flex-1 tw-bg-primary-red tw-h-2"></div>
      </div>
      <Offer {...offer} isSingleOffer selectedOffer={selectedOffer} />
      <div className="tw-mt-32">
        {BENEFITS.map((benefit, index) => (
          <div
            key={index}
            className="tw-flex tw-items-center tw-font-sans tw-text-grayscale-80 tw-mb-8"
          >
            <img src={CheckMark} className="tw-mr-8" />
            <div className="tw-py-4 tw-w-full tw-border-0 tw-border-b tw-border-solid tw-border-neutral-200">
              {benefit}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SingleOffer;
